import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Company, PowerUser } from '@ridango/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import Env from '@ridango/core/env';

@Injectable({
    providedIn: 'root'
})
export class CompanyNgrxService {
    constructor(
        @Inject('ENV') private env: Env,
        private http: HttpClient
    ) {}

    getCustomerCompanies(): Observable<Company[]> {
        const url = `${this.env.API_GATEWAY_URL}/core/customer/v3/region/${this.env.REGION_ID}/company`;
        return this.http.get(url).pipe(
            map((companies: Company[]) => {
                companies.map((c) => (c.display = c.name));
                return companies;
            })
        );
    }

    fetchCompany(companyId): Observable<Company> {
        const url = `${this.env.API_GATEWAY_URL}/core/customer/v3/region/${this.env.REGION_ID}/company/${companyId}`;
        return this.http.get(url).pipe(
            map((c: Company) => {
                return c;
            })
        );
    }

    saveCompanyProfile(payload): Observable<Company> {
        const url = `${this.env.API_GATEWAY_URL}/core/customer/v3/region/${this.env.REGION_ID}/company`;
        return this.http.post<Company>(url, payload);
    }

    updateCompanyProfile(payload, companyId): Observable<Company> {
        const url = `${this.env.API_GATEWAY_URL}/core/customer/v3/region/${this.env.REGION_ID}/company/${companyId}`;
        return this.http.put<Company>(url, payload);
    }

    updateDepartmentProfile(payload, companyId): Observable<Company> {
        const url = `${this.env.API_GATEWAY_URL}/core/customer/v3/region/${this.env.REGION_ID}/company/${companyId}`;
        return this.http.put<Company>(url, payload);
    }

    getPowerUsers(companyId): Observable<PowerUser[]> {
        const url = `${this.env.API_GATEWAY_URL}/core/customer/v3/region/${this.env.REGION_ID}/company/${companyId}/users`;
        return this.http.get(url).pipe(
            map((pu: PowerUser[]) => {
                return pu;
            })
        );
    }

    addPowerUser(payload, companyId): Observable<PowerUser[]> {
        const url = `${this.env.API_GATEWAY_URL}/core/customer/v3/region/${this.env.REGION_ID}/company/${companyId}/users`;
        return this.http.post(url, payload).pipe(
            map((pu: PowerUser[]) => {
                return pu;
            })
        );
    }

    deletePowerUser(companyId, userId): Observable<any> {
        const url = `${this.env.API_GATEWAY_URL}/core/customer/v3/region/${this.env.REGION_ID}/company/${companyId}/users/${userId}`;
        return this.http.delete(url); // returns ""
    }
}
